import React, { useState } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

export function SwipeToDismiss({ values = {} }: { values?: FieldValues }) {
  const [items, setItems] = useState([1, 2, 3])
  const [nextId, setNextId] = useState(4)
  const swipeThreshold = values.swipeThreshold ?? 80
  const initialX = values.initialX ?? -40
  const exitX = values.exitX ?? 200
  const dragScale = values.dragScale ?? 1.02

  const handleDragEnd = (id: number, info: { offset: { x: number } }) => {
    if (Math.abs(info.offset.x) > swipeThreshold) {
      setItems((prev) => prev.filter((i) => i !== id))
      setTimeout(() => {
        setNextId((n) => {
          setItems((prev) => [...prev, n])
          return n + 1
        })
      }, 400)
    }
  }

  return (
    <div className="flex flex-col items-center justify-center h-full gap-2 p-3 overflow-hidden">
      <AnimatePresence mode="popLayout">
        {items.map((id) => (
          <motion.div
            key={id}
            layout
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            onDragEnd={(_, info) => handleDragEnd(id, info)}
            initial={{ opacity: 0, x: initialX }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: exitX, transition: { duration: 0.2 } }}
            whileDrag={{ scale: dragScale }}
            className="w-full max-w-[180px] h-10 bg-white rounded-lg shadow-sm border border-gray-100 flex items-center px-3 cursor-grab active:cursor-grabbing shrink-0"
          >
            <div className="w-5 h-5 rounded-full bg-amber-400 mr-2 shrink-0" />
            <span className="text-[10px] text-gray-600">Swipe card #{id}</span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  )
}
